import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { ToastContainer, ToastStore } from "react-toasts";

import CartItem from "./components/CartItem";
import OrderStyles from "./Order.css";

import utilities from "./components/Utilities";
let Utilities = new utilities();

export default class Order extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: {},
      isAdmin: false,
      user: {}
    };
  }

  printOrder = () => {
    window.print();
  };

  getUser = () => {
    let url = window.location.href;
    let parts = url.split("/");
    let id = parts[parts.length - 1];
    let apiUrl = "/api/user/" + id;

    if (id.length === 24) {
      apiUrl = "/api/user/" + parts[parts.length - 2] + "/" + id;
    }

    window.globalVars.server.api({
      method: "get",
      url: apiUrl,
      data: {},
      then: function(res) {
        if (Utilities.isENU(res.data.data)) {
          ToastStore.error("Coudln't get user");
        } else {
          this.setState({
            user: res.data.data
          });
        }
      }.bind(this),
      catch: function(e) {
        ToastStore.error("Coudln't get user");
      }.bind(this)
    });

    if (id.length === 24) {
      this.setState({
        pageHeaderTitle: "Order Details"
      });
    }
  };

  getOrder = () => {
    console.log("GETTING ORRDER");

    let url = window.location.href;
    let parts = url.split("/");
    let id = parts[parts.length - 1];

    if (id.length === 24) {
      this.setState({
        isAdmin: true
      });
    }

    window.globalVars.server.api({
      method: "get",
      url:
        "/api/order/details/" +
        (id.length !== 24 ? id : parts[parts.length - 2] + "/" + id),
      data: {},
      then: function(res) {
        console.log("GOT ORDER", res);

        if (Utilities.isENU(res.data) || res.data.success === false) {
          ToastStore.error("Coudln't get orders");
        } else {
          this.setState(
            {
              order: res.data.data
            },
            function() {
              if (this.state.isAdmin) {
                this.getUser();
              }
            }
          );
        }
      }.bind(this),
      catch: function(e) {
        ToastStore.error("Coudln't get orders");
      }.bind(this)
    });
  };

  updateStatus = (status, notify) => {
    let apiUrl = "/api/order/update/status";
    let url = window.location.href;
    let parts = url.split("/");
    let id = parts[parts.length - 1];

    if (id.length === 24) {
      apiUrl += "/supplier";
    }

    if (this.state.notifyCheckBox) {
      apiUrl += "/notify";
    }

    window.globalVars.server.api({
      method: "post",
      url: apiUrl,
      data: {
        orderId: this.state.order._id,
        status: status,
        key: id.length === 24 ? parts[parts.length - 1] : null
      },
      then: function(res) {
        if (Utilities.isENU(res.data) || res.data.success === false) {
          if (notify) {
            ToastStore.error("Coudln't update status");
          } else {
            ToastStore.error("Couldn't update status");
          }
        } else {
          if (notify) {
            ToastStore.success("Notification Sent");
          } else {
            ToastStore.success("Status Updated");
          }
          this.getOrder();
        }
      }.bind(this),
      catch: function(e) {
        ToastStore.error("Coudln't update status");
      }.bind(this)
    });
  };

  handleChange = (name, value) => {
    if (name === "status") {
      this.updateStatus(value);
    }
  };

  componentDidMount() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    document.title =
      window.globalVars.pageTitleBefore +
      "Order" +
      window.globalVars.pageTitleAfter;
    this.getOrder();

    let user = JSON.parse(localStorage.getItem("user"));

    if (!Utilities.isENU(user) && user.type < 3) {
      this.setState({
        isAdmin: true
      });
      // this.getUser();
    }
  }

  render() {
    return (
      <div className='order-container'>
        <div className='main-container'>
          <div className='order'>
            <h1 className='no-print'>
              {this.state.pageHeaderTitle || "My account"}
            </h1>
            <section>
              <h2 className='no-print'>Order Details</h2>
              <button
                onClick={() => {
                  this.printOrder();
                }}
                className='no-print print-invoice-btn'
              >
                Print Invoice
              </button>
              <hr className='orange no-print' />
              <div className='details'>
                {this.state.isAdmin && !Utilities.isENU(this.state.user._id) && (
                  <div>
                    <div className='detail'>
                      <label className='field'>Name</label>
                      <p className='value'>
                        {this.state.user.firstName +
                          " " +
                          this.state.user.lastName}
                      </p>
                    </div>
                    <div className='detail'>
                      <label className='field'>Email</label>
                      <p className='value'>{this.state.user.email}</p>
                    </div>
                    <div className='detail'>
                      <label className='field'>Mobile</label>
                      <p className='value'>{this.state.user.tel}</p>
                    </div>
                    <div className='detail'>
                      <label className='field'>Stripe Id</label>
                      <p className='value'>{this.state.order.stripeId}</p>
                    </div>
                  </div>
                )}
                <div className='detail'>
                  <label className='field'>Order Number</label>
                  <p className='value'>{this.state.order._id || ""}</p>
                </div>
                <div className='detail'>
                  <label className='field'>Date</label>
                  <p className='value'>
                    {Utilities.isENU(this.state.order._id)
                      ? ""
                      : Utilities.formatDate(
                          this.state.order.createdAt,
                          "DD/MM/YYYY"
                        )}
                  </p>
                </div>
                {/*<button onClick={() => { this.updateStatus(this.state.order.status, true) }}>Send email of current status</button>*/}
                <div className='detail'>
                  <label className='field'>Order State</label>
                  {this.state.isAdmin && (
                    <div>
                      <div className='notify-checkbox'>
                        <label className='control control--checkbox'>
                          Notify customer
                          <input
                            checked={this.state.notifyCheckBox}
                            onChange={() => {
                              this.setState({
                                notifyCheckBox: !this.state.notifyCheckBox
                              });
                            }}
                            id='terms'
                            type='checkbox'
                            defaultValue='checked'
                          />
                          <div className='control__indicator'></div>
                        </label>
                      </div>
                      <select
                        onChange={e => {
                          this.handleChange("status", e.target.value);
                        }}
                        id='status'
                        value={this.state.order.status || "Open"}
                      >
                        <option value='Open'>Open</option>
                        <option value='Shipped'>Shipped</option>
                        <option value='Cancelled'>Cancelled</option>
                      </select>
                    </div>
                  )}
                  {!this.state.isAdmin && (
                    <p className='value'>{this.state.order.status || "Open"}</p>
                  )}
                </div>
                <div className='address detail'>
                  <label className='field'>Billing Address</label>
                  {!Utilities.isENU(this.state.order._id) &&
                  this.state.order.billingAddres ? (
                    <div className='value'>
                      {window.region === "SG" && (
                        <p>{this.state.order.billingAddres.address1}</p>
                      )}
                      {window.region === "SG" && (
                        <p>{this.state.order.billingAddres.address2}</p>
                      )}
                      {window.region === "SG" && (
                        <p>{this.state.order.billingAddres.address3}</p>
                      )}
                      {window.region === "MY" && (
                        <p>{this.state.order.billingAddres.address1My}</p>
                      )}
                      {window.region === "MY" && (
                        <p>{this.state.order.billingAddres.address2My}</p>
                      )}
                      {window.region === "MY" && (
                        <p>{this.state.order.billingAddres.cityMy}</p>
                      )}
                      {window.region === "MY" && (
                        <p>{this.state.order.billingAddres.postalCodeMy}</p>
                      )}
                      {window.region === "MY" && (
                        <p>{this.state.order.billingAddres.stateMy}</p>
                      )}
                    </div>
                  ) : (
                    <p className='no_address'>
                      This user has no billing address
                    </p>
                  )}
                </div>

                <div className='address detail'>
                  <label className='field'>Delivery Address</label>
                  {!Utilities.isENU(this.state.order._id) &&
                  this.state.order.deliveryAddress ? (
                    <div className='value'>
                      {window.region === "SG" && (
                        <p>{this.state.order.deliveryAddress.address1}</p>
                      )}
                      {window.region === "SG" && (
                        <p>{this.state.order.deliveryAddress.address2}</p>
                      )}
                      {window.region === "SG" && (
                        <p>{this.state.order.deliveryAddress.address3}</p>
                      )}
                      {window.region === "MY" && (
                        <p>{this.state.order.deliveryAddress.address1My}</p>
                      )}
                      {window.region === "MY" && (
                        <p>{this.state.order.deliveryAddress.address2My}</p>
                      )}
                      {window.region === "MY" && (
                        <p>{this.state.order.deliveryAddress.cityMy}</p>
                      )}
                      {window.region === "MY" && (
                        <p>{this.state.order.deliveryAddress.postalCodeMy}</p>
                      )}
                      {window.region === "MY" && (
                        <p>{this.state.order.deliveryAddress.stateMy}</p>
                      )}
                    </div>
                  ) : (
                    <p className='no_address'>
                      This user has no delivery address
                    </p>
                  )}
                </div>
                {this.state.order.tax && (
                  <div className='detail'>
                    <label className='field'>Tax Rate</label>
                    <p className='value'>{this.state.order.tax}%</p>
                  </div>
                )}
                <div className='detail bold'>
                  <label className='field'>Total</label>
                  <p className='value'>
                    {window.currency}
                    {this.state.order.total || ""}
                  </p>
                </div>
              </div>
            </section>
            <section>
              <div className='cart-items'>
                {!Utilities.isENU(this.state.order.items) &&
                  this.state.order.items.map(item => {
                    return (
                      <CartItem
                        item={item}
                        section='order'
                        price={item.price}
                        onPriceUpdated={() => {}}
                        isAdmin={this.state.isAdmin}
                      />
                    );
                  })}
              </div>
            </section>
            {!this.state.isAdmin && (
              <Link to='/profile' className='back-btn no-print'>
                Back
              </Link>
            )}
          </div>
        </div>
        <ToastContainer store={ToastStore} position={ToastContainer.POSITION.BOTTOM_RIGHT}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Order.js